// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__MRom4","buttons":"PendingPaymentAlert_buttons__1LIqm"};